import React, { useState } from 'react';
import { Button } from '@mui/material';
import './index.scss';

interface SidebarItem {
  key: string; // Unique key for each sidebar item
  label: string; // Label to display in the sidebar
}

interface InnerSidebarProps {
  items: SidebarItem[]; // Array of sidebar items
  onSelect: (component: string) => void; // Callback for when an item is selected
}

const DetailInnerSidebar: React.FC<InnerSidebarProps> = ({ items, onSelect }) => {
    console.log("items", items);
  const [activeButton, setActiveButton] = useState<string | null>("general");

  const handleButtonClick = (key: string) => {
    setActiveButton(key);
    onSelect(key); // Trigger the onSelect callback
  };

  return (
    <div className="inner-sidebar">
      {items.map((item:any) => (
        <Button
          key={item.key}
          variant="text" // Text-only button
          className={`sidebar-btn ${activeButton === item.key ? 'active' : ''}`}
          onClick={() => handleButtonClick(item.key)}
        >
          {item.values}
        </Button>
      ))}
    </div>
  );
};

export default DetailInnerSidebar;
